<template>
    <div id="sme-table" class="animate__parent">
        <h2 class="h2 _mb-32-24">Тарифы</h2>
        <div class="switch">
            <div class="switch__container">
                <div class="switch__item">
                    <input
                        v-model="charterContentType"
                        type="radio"
                        id="table-1"
                        value="first"
                        checked
                    >
                    <label class="switch__label" for="table-1">
                        <span>Малому и среднему</span>
                    </label>
                </div>
                <div class="switch__item">
                    <input
                        v-model="charterContentType"
                        type="radio"
                        id="table-2"
                        value="second"
                    >
                    <label class="switch__label" for="table-2">
                        <span>Крупному бизнесу</span>
                    </label>
                </div>
            </div>
        </div>
        <div v-show="charterContentType === 'first'" class="_mt-32">
            <table-sme
                :content="smallBusinessData"
            ></table-sme>
        </div>

        <div v-show="charterContentType === 'second'" class="_mt-32">
            <table-sme
                :content="bigBusinessData"
            ></table-sme>
        </div>
    </div>
</template>

<script>
import TableSme from './TableSme.vue';
import { getQueryParameterByName } from '../../assets/js/utils'
import axios from "axios";

export default {
    name: "TableSmeWrap",
    components: {
        TableSme,
    },
    props: {
        contentLink: {
            type: String,
            required: true,
        }
    },
    data() {
        return {
            charterContentType: 'first',
            content: [],
        }
    },
    computed: {
        smallBusinessData() {
            return this.content.filter(item => item.business === 'small');
        },
        bigBusinessData() {
            return this.content.filter(item => item.business === 'big');
        }
    },
    mounted() {
        this.fetchContent();
        this.checkGetParams();
    },
    methods: {
        checkGetParams() {
            if (getQueryParameterByName('tab') === 'second') {
                this.charterContentType = 'second';
            }
        },
        fetchContent() {
            axios.get(this.contentLink, {headers: {'Accept': 'application/vnd.api+json'}})
                .then(res => {
                    this.content = JSON.parse(JSON.stringify(res.data));
                })
                .catch(err => {
                    console.error(err.message)  // eslint-disable-line
                })
        }
    }
}
</script>
